module.exports = __webpack_public_path__ + "static/media/history_27.f546f764.jpg";